import * as actionGeneral from '../constant/action-type/general';

const initialState = {
  uploading: [],
  imagesToUpload: {},
  failToUpload: [],
  uploadCooldowns: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionGeneral.FETCH_FROM_IDB:
      return {
        ...initialState,
        imagesToUpload: action.payload.serverImages?.imagesToUpload || {},
        failToUpload: action.payload.serverImages?.failToUpload || []
      };
    case actionGeneral.SAGA_STORE_SERVER_IMAGE:
      return {
        ...state,
        imagesToUpload: {
          ...state.imagesToUpload,
          [action.payload.img.id]: action.payload.img
        }
      };
    case actionGeneral.SAGA_REMOVE_STORED_SERVER_IMAGE: {
      const { [action.payload.id]: _removedImage, ...imagesToUpload } =
        state.imagesToUpload;
      const { [action.payload.id]: _removedCooldown, ...uploadCooldowns } =
        state.uploadCooldowns;

      return {
        ...state,
        imagesToUpload,
        failToUpload: state.failToUpload.filter(id => id !== action.payload.id),
        uploadCooldowns
      };
    }
    case actionGeneral.SAGA_ADD_SERVER_IMAGE_UPLOADING:
      if (state.uploading.includes(action.payload.id)) return state;
      return {
        ...state,
        uploading: [...state.uploading, action.payload.id]
      };
    case actionGeneral.SAGA_ADD_FAIL_UPLOAD_IMAGE:
      if (state.failToUpload.includes(action.payload.id)) return state;
      return {
        ...state,
        failToUpload: [...state.failToUpload, action.payload.id]
      };
    case actionGeneral.SET_SERVER_IMAGE_UPLOAD_COOLDOWN:
      return {
        ...state,
        uploadCooldowns: {
          ...state.uploadCooldowns,
          [action.payload.id]: {
            availableAt: action.payload.availableAt,
            failureCount: action.payload.failureCount
          }
        }
      };
    case actionGeneral.CLEAR_SERVER_IMAGE_UPLOAD_COOLDOWN: {
      const { [action.payload.id]: _removedCooldown, ...uploadCooldowns } =
        state.uploadCooldowns;

      return {
        ...state,
        uploadCooldowns
      };
    }
    case actionGeneral.SAGA_ADD_SERVER_IMAGE_UPLOAD_ENABLE: {
      const images = action.payload.images || [];
      const uploadCooldowns = { ...state.uploadCooldowns };

      images.forEach(id => {
        delete uploadCooldowns[id];
      });

      return {
        ...state,
        uploadCooldowns
      };
    }
    case actionGeneral.SAGA_REMOVE_SERVER_IMAGE_UPLOADING:
      return {
        ...state,
        uploading: state.uploading.filter(id => id !== action.payload.id)
      };
    default:
      return state;
  }
};

export default reducer;
